export const TICKET_NOTES_COLOR_PALETTE = Object.freeze([
  '#9796F3',
  '#82F0FF',
  '#A7FFB2',
  '#6C9DFF',
  '#FBB979',
  '#FF5F82',
]);
